export enum TRACKING_EVENTS {
  USER_SIGNED_UP = 'user_signed_up',
  USER_LOGGED_IN = 'user_logged_in',
  USER_SELECTED_COMPANY = 'user_selected_company',
  CREDIT_ASSIGNMENT_EXPORT = 'credit_assignment_export',
  CARD_RENEWAL_MESSAGE_VIEWED = 'card_renewal_message_viewed',
  CARD_RENEWAL_DETAILS_CLICKED = 'card_renewal_details_clicked',
}
